import { AppointmentType, AvailabilityType } from '../../../constants'
import { appointmentTypeTheme, availabilityTheme } from '../constants'
import { Theme } from '../types'

const getTheme = (availability: AvailabilityType, appointmentTypes: AppointmentType[]): Theme => {
  switch (true) {
    case availability === AvailabilityType.UNAVAILABLE:
      return availabilityTheme.UNAVAILABLE
    case Boolean(appointmentTypes && appointmentTypes.length === 1):
      return appointmentTypeTheme[appointmentTypes[0]]
    case Boolean(appointmentTypes && appointmentTypes.length > 1):
      return appointmentTypeTheme['MULTIPLE']
    default:
      return availabilityTheme.AVAILABLE
  }
}

export { getTheme }
